'use strict';

var ServiceAdjustmentNumberOfStopsAggregationFactory = function ServiceAdjustmentNumberOfStopsAggregationFactory(DataAggregationFactory) {
  function ServiceAdjustmentNumberOfStopsAggregation() {
    DataAggregationFactory.call(this, 'service-share', 'demand-adjustment-number-of-stops');
  }
  ServiceAdjustmentNumberOfStopsAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  ServiceAdjustmentNumberOfStopsAggregation.constructor = ServiceAdjustmentNumberOfStopsAggregation;
  ServiceAdjustmentNumberOfStopsAggregation.prototype.aggregate = function (data) {
    var aggregatedNumberOfStops = {};
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      var item = data[index];
      if (!aggregatedNumberOfStops[item.numberOfStops]) {
        aggregatedNumberOfStops[item.numberOfStops] = [];
      }
      aggregatedNumberOfStops[item.numberOfStops].push(item);
    }
    return aggregatedNumberOfStops;
  };
  return ServiceAdjustmentNumberOfStopsAggregation;
};
ServiceAdjustmentNumberOfStopsAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = ServiceAdjustmentNumberOfStopsAggregationFactory;